import { render, staticRenderFns } from "./VegetativeMonitoringTabularCell.vue?vue&type=template&id=1e2442d3"
import script from "./VegetativeMonitoringTabularCell.vue?vue&type=script&lang=js"
export * from "./VegetativeMonitoringTabularCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports